import Vue from "vue";
import { filterCapitalize } from "./capitalize";
import { filterFormatDate } from "./formatDate";
import { filterFormatMonth } from "./formatMonth";
import { filterExchangeRate } from "./formatExchangeRate";
import { filterFormatDateTimeMinutes } from "./formatDateTimeMinutes";
import { filterFormatDateTimeSeconds } from "./formatDateTimeSeconds";
import { filterFormatDateTimeMilliseconds } from "./formatDateTimeMiliseconds";
import { filterPrice } from "./price";
import { filterPretty } from "./pretty";
import { filterNumber } from "./number";
import { filterInt } from "./int";
import { filterAppendBackend } from "./appendBackend";
import { filterJoin } from "./filterJoin";
import { bankAccountNumber } from "./bankAccountNumber";
import { bankAccountIBAN } from "./bankAccountIBAN";
import { bold as filterBold } from "./bold";
import { filterFormatTimeMinutes } from "./formatTimeMinutes";
import { filterFormatTimeSeconds } from "./formatTimeSeconds";

export const filters = {
  filterCapitalize,
  filterFormatDate,
  filterFormatMonth,
  filterExchangeRate,
  filterFormatDateTimeMinutes,
  filterFormatDateTimeSeconds,
  filterFormatDateTimeMilliseconds,
  filterFormatTimeMinutes,
  filterFormatTimeSeconds,
  filterPrice,
  filterPretty,
  filterNumber,
  filterInt,
  filterAppendBackend,
  bankAccountNumber,
  bankAccountIBAN,
  filterJoin,
  filterBold,
};

export type Filters = typeof filters;

Vue.prototype.$filters = filters;

// TODO - remove all filters from Vue constructor after replacing all filters
